import type {
  Direction,
  LogicalAlignment,
} from '@wix/editor-elements-common-utils';

const directionToLogicalAlignmentMap: Record<Direction, LogicalAlignment> = {
  ltr: 'start',
  rtl: 'end',
};

export const convertDirectionToLogicalAlignment = (
  direction: Direction,
): LogicalAlignment => directionToLogicalAlignmentMap[direction];
